import clsx from 'clsx';
import { NextPage } from 'next';
import SEO from '@/components/head/Seo';
import Nav from '@/components/navigation/Public';
import Hero from '@/components/heros/Public';
import Directory, { DirectoryItem } from '@/components/lists/Directory';
import Footer from '@/components/legal/Footer';
import SignUpForm from '@/components/forms/Newsletter';
import layoutStyles from '@/components/Layout/styles.module.scss';
import donutChartMaker from '@/features/resources/DonutChartMaker/settings';
import pieChartMaker from '@/features/resources/PieChartMaker/settings';
import bubbleChartMaker from '@/features/resources/BubbleChartMaker/settings';
import lineGraphMaker from '@/features/resources/LineGraphMaker/settings';
import barChartMaker from '@/features/resources/BarGraphMaker/settings';
import scatterPlotMaker from '@/features/resources/ScatterPlotMaker/settings';
import horizontalBarChartMaker from '@/features/resources/HorizontalBarGraphMaker/settings';
import doubleBarChartMaker from '@/features/resources/DoubleBarGraphMaker/settings';
import stackedBarGraphMaker from '@/features/resources/StackedBarGraphMaker/settings';
import areaChartMaker from '@/features/resources/AreaChartMaker/settings';
import gaugeChartMaker from '@/features/resources/GaugeChartMaker/settings';
import radarChartMaker from '@/features/resources/RadarChartMaker/settings';

// @ts-ignore
const Page: NextPage = () => {
  const heading = 'Charts';
  const subHeading = 'Create free charts, graphs, and sharable images.';
  const pages = [
    pieChartMaker,
    donutChartMaker,
    barChartMaker,
    bubbleChartMaker,
    scatterPlotMaker,
    lineGraphMaker,
    horizontalBarChartMaker,
    doubleBarChartMaker,
    stackedBarGraphMaker,
    areaChartMaker,
    gaugeChartMaker,
    radarChartMaker,
  ];

  return (
    <>
      <SEO title={heading} description={subHeading} />
      <div role="main" className={clsx(layoutStyles.main, '-bgc-white')}>
        <Nav />
        <Hero heading={heading} subHeading={subHeading} />

        <Directory>
          {pages.map((page) => (
            <DirectoryItem
              key={page.slug}
              heading={page.heading || page.title || ''}
              description={page.description}
              timestamp={page.updatedAt}
              url={`/${page.slug}`}
              featuredImageUrl={page.images.resourceUrl}
              featuredImageAlt={page.images.resourceUrlAlt || ''}
            />
          ))}
        </Directory>

        <SignUpForm />
        <Footer />
      </div>
    </>
  );
};

export default Page;
